import React, { useState } from 'react'

import circle_green from '../../../../images/education/circle_green.svg'
import circle from '../../../../images/main/curcle.svg'
import personal_1 from '../../../../images/education/personal1.jpg'
import personal_2 from '../../../../images/education/personal2.jpg'
import personal_3 from '../../../../images/education/personal4.jpg'
import personal_4 from '../../../../images/education/personal5.jpg'
import personal_5 from '../../../../images/education/personal6.jpg'

import styles from './styles.module.scss'
import { Link } from 'react-router-dom'

const EducationPrograms = () => {
  const [activeCity, setActiveCity] = useState(0)
  const city = ['Кейс-чемпионат', 'РТУ МИРЭА', 'МГУ имени М. В. Ломоносова', 'Петушинский колледж', 'РУДН']

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftSide}>
        <div>
          <div className={styles.down_side}>
            <p className={styles.title}>Образование с Generium</p>
            <p className={styles.text}>Образовательные программы</p>

            <p className={styles.text2}>
              Generium сотрудничает с лучшими учебными учреждениями России. Сейчас Generium реализует ряд
              образовательных проектов по подготовке высококвалифицированных, перспективных молодых специалистов.
            </p>
          </div>
        </div>
        <div>
          <p className={styles.text2}>
            Generium сотрудничает с лучшими учебными учреждениями России. Сейчас Generium реализует ряд образовательных
            проектов по подготовке высококвалифицированных, перспективных молодых специалистов.
          </p>
          <div className={styles.list_scroll_box}>
            <div className={styles.list_wrapper}>
              {city.map((item, index) => (
                <div className={styles.list} key={index}>
                  <svg
                    width='8'
                    height='8.5'
                    viewBox='0 0 8 9'
                    xmlns={activeCity === index ? circle_green : circle}
                    className={activeCity === index ? styles.circle_active : styles.circle}
                  >
                    <path
                      d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z'/>
                  </svg>
                  <p
                    onClick={() => setActiveCity(index)}
                    className={activeCity === index ? styles.title_name_active : styles.title_name}
                  >
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rightSide}>
        <div className={styles.rightSide_wrapper}>
          <p className={styles.text}>Образовательные программы</p>
          <div className={styles.rightSide_wrapper_info}>
            <div className={styles.rightSide_left}>
              <div className={styles.rightSide_left_content}>
                <p className={styles.rightSide_left_p1}>
                  {activeCity === 0
                    ? 'Мероприятие'
                    :activeCity === 1
                      ? 'РТУ МИРЭА'
                      : activeCity === 2
                          ? 'МГУ имени М. В. Ломоносова'
                          : activeCity === 3
                            ? 'Петушинский колледж'
                            : activeCity === 4
                              ? 'РУДН'
                              : 'РУДН'}
                </p>
                <p className={styles.rightSide_left_p2}>
                  {activeCity === 0
                    ? 'Всероссийский кейс-чемпионат Generium'
                    :activeCity === 0
                      ? 'Образовательный проект Mabstudy'
                      : activeCity === 1
                        ? '«Образовательный проект Mabstudy»'
                        : activeCity === 2
                            ? 'Регенеративная биомедицина'
                            : activeCity === 3
                              ? 'Программа обучения и трудоустройства аппаратчиков-операторов'
                              : 'Создание и разработка лекарственных препаратов'}
                </p>
                <p className={styles.rightSide_left_p3}>
                  {activeCity === 0
                    ? 'В 2023 году компания провела первый Всероссийский кейс-чемпионат по биотехнологии и химии. В нем приняли участие студенты профильных вузов. Мероприятие будет проводиться ежегодно.'
                    :activeCity === 1
                      ? 'Инновационная программа для бакалавров и магистров, включающая в себя научно-образовательные лаборатории, лекционный и практический курс и программу стажировок'
                      : activeCity === 2
                          ? 'Первая в стране межфакультетская магистерская программа, реализуемая факультетом ' +
                          'фундаментальной медицины и биологическим факультетом МГУ имени М. В. Ломоносова совместно с Generium'
                          : activeCity === 3
                            ? 'Реализуемая совместно с Generium, образовательная программа по подготовке аппаратчиков-операторов в биотехнологии'
                            : activeCity === 4
                              ? 'Первая магистерская программа на русском языке, охватывающая все этапы разработки — от ' +
                              'определения мишени до выведения лекарственного препарата на рынок'
                              : 'Инновационная программа для бакалавров и магистров, включающая в себя научно-образовательные лаборатории, лекционный и практический курс и программу стажировок'}
                </p>
              </div>

              {activeCity === 0 ? (
                <a className={styles.button} href='https://generium-champ.ru/' target='_blank'>
                  Подробнее о чемпионате <span>&rarr;</span>
                </a>
              ) : activeCity === 1 ? (
                <Link className={styles.button} to='/students/mabstudy' state='/students/mabstudy'>
                  Подробнее о программе <span>&rarr;</span>
                </Link>
              ) : (
                <a
                  className={styles.button}
                  target='_blank'
                  href={
                    activeCity === 1
                      ? 'http://generium-masterprogram.ru/'
                      : activeCity === 2
                          ? 'http://www.fbm.msu.ru/admissions/magistracy/'
                          : activeCity === 3
                            ? 'https://xn--c1aona.xn--p1ai/abiturientam/napravleniya-obucheniya/'
                            : activeCity === 4
                              ? 'https://innovativedrugs.ru/'
                              : null
                  }
                >
                  {' '}
                  Подробнее о программе <span>&rarr;</span>{' '}
                </a>
              )}
            </div>
            <div className={styles.rightSide_right}>
              <img
                draggable='false'
                src={
                  activeCity === 0
                    ? personal_1
                    :activeCity === 1
                    ? personal_2
                    : activeCity === 2
                    ? personal_3
                    : activeCity === 3
                    ? personal_4
                    : activeCity === 4
                    ? personal_5
                    : personal_1
                }
                alt='personal'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EducationPrograms
